export enum FIRESTORE_COLLECTIONS {
  PAIRING_TOKENS = "pairing_tokens",
  QR_CODE_ORDERS = "qrcode_orders",
  QR_CODES = "qrcodes",
  TOPUP = "topup",
  REPORTS_MOBILE_CODES = "reports_mobile_codes",
  LIVE = "live",
  SYNC_DATA = "sync_data",
  TABLE_META = "table_meta",
  TABLE_STATE = "table_state",
  STORES="stores",
  VERSION_DATA="version_data",
  CHECK_ONLINE="check_online",
  CHECK_PRINT="check_print",
  /** สวิตช์ระดับ channel `app_control/{channel}` (ดู interface/AppControl.ts) */
  APP_CONTROL="app_control",
  /**
   * สั่งการเฉพาะร้าน `app_control_stores/{storeId}` → { reload } (ดู interface/AppControl.ts)
   * แยกออกจาก doc ร้าน `stores/{storeId}` เพื่อไม่ให้เครื่องไหนต้องฟัง root doc ของร้าน
   */
  APP_CONTROL_STORES="app_control_stores"
}
